import React, { useState } from 'react';
import Loader from '../Loader/Loader';
import { useStore } from '../../store/Store';
import {
  registerGoogle,
  loginWithEmailPassword,
  loginGoogle
} from '../../store/ActionLogin';

function LoginForm() {
  let formInit = {
    username: '',
    password: '',
    name: '',
    valid: false,
    errors: []
  };

  const [form, setForm] = useState(formInit);
  const {
    state: { loadingLogin },
    dispatch
  } = useStore();

  const handleSubmitRegister = async e => {
    e.preventDefault();
    registerGoogle(dispatch);
  };
  const handleSubmitLogin = e => {
    e.preventDefault();
    loginWithEmailPassword(dispatch, form.username, form.password);
  };

  const handleSubmitGoogle = e => {
    e.preventDefault();
    loginGoogle(dispatch);
  };

  const handleInput = e => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  const isFormValid = () => {
    if (form.username.length > 0 && form.password.length > 3) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <form>
      <div className="form-group no-display">
        <label htmlFor="username">Usuario</label>
        <input
          type="text"
          className="form-control"
          id="username"
          name="username"
          value={form.username}
          onChange={handleInput}
          aria-describedby="Ingresa nombre de usuario"
          placeholder="Nombre de usuario"
        />
      </div>
      <div className="form-group no-display">
        <label htmlFor="name">Nombre</label>
        <input
          type="text"
          className="form-control"
          id="name"
          name="name"
          value={form.name}
          onChange={handleInput}
          aria-describedby="Ingresa tu nombre"
          placeholder="Nombres"
        />
      </div>
      <div className="form-group no-display">
        <label htmlFor="password">Contraseña</label>
        <input
          type="password"
          className="form-control"
          id="password"
          name="password"
          value={form.password}
          onChange={handleInput}
          aria-describedby="Ingresa contraseña"
          placeholder="Contraseña"
        />
      </div>
      {!loadingLogin ? (
        <div className="Login__buttons">
          <button
            type="submit"
            disabled={!isFormValid()}
            className="btn btn-primary no-display"
            onClick={handleSubmitLogin}
          >
            Iniciar
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={handleSubmitGoogle}
          >
            Iniciar con Google
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={handleSubmitRegister}
          >
            Registrarse
          </button>
        </div>
      ) : (
        <Loader />
      )}
    </form>
  );
}

export default LoginForm;
